import { emailResponseTimeDefaultVal } from "../../../common/shared";

const HelpCenterDefaults = {
  articlesRedirect: {},
  articleRedirectConfig: [],
  cardLinksConfig: [],
  catPopularLinks: [],
  emailResponseTime: emailResponseTimeDefaultVal,
  gladlyAnswersList: [],
  gladlyArticlesRedirect: {},
  gladlyHelpCenterMap: {},
  gladlyNewHelpCenters: [],
  gladlyPropertyMap: () => ({}),
  hasSecondaryHC: false,
  helpCenterCDNResponse: {},
  helpCenterNames: [],
  helpCenterNumbers: {},
  maxCatPopularLinks: 0,
  maxNoOfOrders: 0,
  open: false,
  pageName: '',
  popularTopicsLinks: [],
  quickTools: [],
  reiSalesConfig: {},
  relatedLinksConfig: {},
  retailStoreHoursEvents: [],
  salesHelpLinks: [],
  salesPopularLinks: [],
  selectedCategory: '',
  showContactUsAccordion: false,
  showContactUsOnPage: {},
  showContactUsPage: false,
  showLeftHandNavigation: false,
  showOrderDetails: false,
  showPreviousOrderDays: 30,
  showQuickToolsOnPage: {},
  showSectionCardLinks: false,
  statusForOrdersNotShown: [],
  title: 'REI Help Center',
};
Object.freeze(HelpCenterDefaults);
export default HelpCenterDefaults;